import { render, staticRenderFns } from "./TabHeaders.vue?vue&type=template&id=9c459014&"
import script from "./TabHeaders.vue?vue&type=script&lang=js&"
export * from "./TabHeaders.vue?vue&type=script&lang=js&"
import style0 from "./TabHeaders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports